import React from 'react';
import classnames from 'classnames';
import audiLogo from './audi-logo.svg';
import './AudiLogo.scss';

const AudiLogo = ({
    classNames,
}) => {
    const classes = classnames('b-audi-logo white', classNames);
    return (
        <div className={classes}>
            <img src={audiLogo} alt="Audi Logo" data-testid="audi-logo" />
        </div>
    );
};

export default AudiLogo;

